export default __webpack_public_path__ + "7a318bbc168cafb9fda95c4225090847.png";